import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './onpage-product-wizard.component.scss';
var OnpageProductWizard = /** @class */ (function (_super) {
    tslib_1.__extends(OnpageProductWizard, _super);
    function OnpageProductWizard(element) {
        return _super.call(this, element) || this;
    }
    OnpageProductWizard.prototype.init = function () {
    };
    OnpageProductWizard.prototype.bindEvents = function () {
    };
    return OnpageProductWizard;
}(Base));
export { OnpageProductWizard };



//////////////////
// WEBPACK FOOTER
// ./components/onpage-product-wizard/onpage-product-wizard.component.ts
// module id = 797
// module chunks = 0